<!-- ProductoForm.svelte -->

<script>
	import UploadImage from '../UploadImage.svelte'
	import {execQuery,execMutation} from '../csql.js'
	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	export let item = {}
	export let visible=false

	let loading = false
	let aux_item = {
		id:0,
		touched:0,
		nombre:'',
		descrp:'',
		categoria:'PANTALONES',
		temporada:'ANUAL',
		imagenes:'',
		importe0:0.00,
		importe1:0.00,
		importe2:0.00,
		tag:'',
		extra:'',
		activo:1
	}

	let formdata = {...aux_item,...item}

	let config = []

	async function  get_categorias(){
		loading = true
		let query = `select * from config where tabla in ('categorias','temporadas') and activo=1`
		const data = await execQuery({query})
		loading= false
		config = data.data[0] || []
	}

	function submit(){
		if(sanitizar()){
			guardar()
			visible= false

		}else{
			alert("No puede dejar en blanco el nombre del producto.")
		}
	}

	function cambiar(){
		formdata.activo = formdata.activo===1 ? 0 : 1 
		console.log(formdata.activo)
	}

	function renovar(){
		formdata.touched = parseInt(Date.now()/1000)
		alert("Producto renovado!")
	}

	function sanitizar(){
		if( (formdata["nombre"] || "").trim() === "" ) return false
		formdata["id"] = formdata["id"]
		formdata["touched"] = formdata["id"]===0 ? parseInt(Date.now()/1000) : formdata["touched"]
		formdata["nombre"] = formdata["nombre"].trim()
		formdata["descrp"] = (formdata["descrp"]||"").trim()
		formdata["categoria"] = formdata["categoria"]
		formdata["temporada"] = formdata["temporada"]
		formdata["imagenes"] = (formdata["imagenes"]||"").trim()
		formdata["importe0"] = parseFloat(formdata["importe0"] || 0).toFixed(2)
		formdata["importe1"] = parseFloat(formdata["importe1"] || 0).toFixed(2)
		formdata["importe2"] = parseFloat(formdata["importe2"] || 0).toFixed(2)
		formdata["tag"] = (formdata["tag"]||"").trim()
		formdata["extra"] = (formdata["extra"]||"").trim()
		formdata["activo"] = formdata["activo"]
		return true
	}

	async function guardar(){
		loading = true
		delete formdata.stocku
		let data = {
			tabname: 'productos', 
			mutation: (formdata && formdata.id && formdata.id>0) ? 'update' : 'insert',
			mutationId: 'id',
			params: formdata
		}
		const res = await execMutation(data)
		loading = false
		if(res && res.success==="OK"){
			dispatch('updated')
		}else{
			alert("ERROR, no se realizo actualizacion!!!")
		}
	}

	function mover_foto(idx){
		let array = formdata.imagenes.split(',')
		let elem1 = ''
		let elem2 = ''

		if(idx===0){
			elem2 = array.shift()
			array.push(elem2)

		}else{
			elem1 = array[idx]
			elem2 = array[idx-1]
			array[idx] = elem2
			array[idx-1] = elem1
		} 
		formdata.imagenes = array.join(',')
	}

	function borrar_foto(idx){
		let array = formdata.imagenes.split(',')
		let elem = array.splice(idx,1)
		formdata.imagenes = array.join(',')
	}

	function fileUplaoded(ev){
		let aux_img = formdata.imagenes.split(',').filter( (v,a,i) =>  v )
      	aux_img.push(ev.detail.filename)
      	formdata.imagenes = aux_img.join(",")
	}

	get_categorias()
</script>

<div class="modal">
	<div class="container" id="principal" style="min-width:380px;width:100%;height:100vh;background-color:white;position:relative;top:0;left:0;overflow:auto;margin:0 auto;">
		<div class="no-print" style="text-align:center;background-color: #eeeeee;display: flex;justify-content: space-between;min-width:400px;">
			<button style="background-color: transparent;font-size: 1rem; padding:0;margin:0 15px;">❤️ UP+</button>
		  <slot name="salir"></slot>
		</div> 


		<form on:submit|preventDefault={submit}>
			<!-- <div class="flex flex-row">
				<button class="">Guardar&nbsp;&check;</button>
				<button on:click="{()=>visible=false}">&times;&nbsp;Cancelar</button>
			</div>
 -->
			

			<div class="row v-center">
				<div class="col-sm-4"><input  class="w-full" bind:value={formdata.id} readonly></div>
				<div class="col-sm-8 ">
					<span class="button primary" style="margin:0;padding:2px 6px;" on:click={cambiar}><small>{formdata.activo?'ACTIVO':'NO ACTIVO'}</small></span>
					<span class="button primary" style="margin:0;padding:2px 6px;" on:click={renovar}><small>RENOVAR</small></span>
				</div>
			</div>
			
			<div class="row">
				<div class="col-sm-12 lbl">Nombre</div>
				<div class="col-sm-12"><input class="w-full" type="text" bind:value={formdata.nombre}></div>			

				<div class="col-sm-12 lbl">Descripcion</div>
				<div class="col-sm-12"><textarea class="w-full" rows=3 bind:value={formdata.descrp}></textarea></div>			

				<div class="col-sm-6 lbl">Categoria</div>
				<div class="col-sm-6 lbl">Temporada</div>

				<div class="col-sm-6">
					<select class="w-full" bind:value={formdata.categoria}>
						{#each config.filter(v => v.tabla==='categorias') as cat, index}
							<option value={cat.codigo.toUpperCase()}>{cat.nombre}</option>
						{/each}
					</select>
				</div>			
				<div class="col-sm-6">
					<select class="w-full" bind:value={formdata.temporada}>
						{#each config.filter(v => v.tabla==='temporadas') as temp, index}
							<option value={temp.nombre.toUpperCase()}>{temp.codigo}</option>
						{/each}
					</select>
				</div>			

				<div class="col-sm-4 lbl">Imp MINO</div>
				<div class="col-sm-4 lbl">Imp MAYO</div>
				<div class="col-sm-4 lbl">Costo</div>

				<div class="col-sm-4"><input class="w-full" type="text" bind:value={formdata.importe1}></div>			
				<div class="col-sm-4"><input class="w-full" type="text" bind:value={formdata.importe0}></div>			
				<div class="col-sm-4"><input class="w-full" type="text" bind:value={formdata.importe2}></div>			

				<div class="col-sm-12 lbl">Tag</div>
				<div class="col-sm-12"><input class="w-full" type="text" bind:value={formdata.tag}></div>			



			</div>
			<div class="row">

				<div class="col-sm-5">&nbsp;</div>
				<div class="col-sm-3"><button class="w-full inverse">Guardar&nbsp;&check;</button></div>
				<div class="col-sm-3"><button class="w-full" on:click="{()=>visible=false}">&Cross;&nbsp;Cancelar</button></div>
				<div class="col-sm-1">&nbsp;</div>
			</div>

<!-- 
			<div class="flex flex-col flex-none mb-2">
				<span class="text-xs text-gray-400 ml-1 capitalize">#</span>
				<input  class="border flex-none px-2" bind:value={formdata.id} readonly>
			</div>

			<div class="flex flex-col flex-1 mb-2">
				<span class="text-xs text-gray-400 ml-1 capitalize">nombre</span>
				<input type="text" class="border flex-1 px-2" bind:value={formdata.nombre} >
			</div>

			<div class="flex flex-col flex-1 mb-2">
				<span class="text-xs text-gray-400 ml-1 capitalize">descrp</span>
				<textarea cols=3 class="border flex-1 px-2" bind:value={formdata.descrp}></textarea>
			</div>

			<div class="flex flex-wrap">
				<div class="flex flex-col flex-1 mb-2">
					<span class="text-xs text-gray-400 ml-1 capitalize">categoria</span>
					<select bind:value={formdata.categoria}>
							{#each config.filter(v => v.tabla==='categorias') as cat, index}
								<option value={cat.nombre.toUpperCase()}>{cat.codigo}</option>
							{/each}
					</select>
				</div>

				<div class="flex flex-col flex-1 mb-2">
					<span class="text-xs text-gray-400 ml-1 capitalize">temporada</span>
					<select bind:value={formdata.temporada}>
						{#each config.filter(v => v.tabla==='temporadas') as temp, index}
							<option value={temp.nombre.toUpperCase()}>{temp.codigo}</option>
						{/each}
					</select>
				</div>			

			</div>

			<div class="flex flex-wrap">
				<div class="flex flex-col flex-1 mb-2">
					<span class="text-xs text-gray-400 ml-1 capitalize">importe MAY</span>
					<input type="text" class="border flex-1 px-2" bind:value={formdata.importe0} >
				</div>

				<div class="flex flex-col flex-1 mb-2">
					<span class="text-xs text-gray-400 ml-1 capitalize">importe MIN</span>
					<input type="text" class="border flex-1 px-2" bind:value={formdata.importe1} >
				</div>
			</div>

			<div class="flex flex-col flex-1 mb-2">
				<span class="text-xs text-gray-400 ml-1 capitalize">tag</span>
				<textarea cols=3 class="border flex-1 px-2" bind:value={formdata.tag}></textarea>
			</div>

			<div class="flex flex-col flex-1 mb-2">
				<span class="text-xs text-gray-400 ml-1 capitalize">extra</span>
				<textarea cols=3 class="border flex-1 px-2" bind:value={formdata.extra}></textarea>
			</div>
 -->
		{#if item.id && item.id>0}

			<div class="row">
				<div class="col-sm-12">Fotos</div>
				{#each formdata.imagenes.split(',') as img, index}
					<div class="col-sm">
						<img src="{'upload/'+img}" alt="">
						<span class="button"  style="margin:1px;padding:1px 3px;" on:click={()=>mover_foto(index)}>&lt;</span>
						<span class="button"  style="margin:1px;padding:1px 3px;" on:click={()=>borrar_foto(index)}>&Cross;</span>
					</div>

				{/each}
				<div class="col-sm"><UploadImage image_id={item.id} on:uploaded={fileUplaoded}/></div>
			</div>


<!-- 			<div class="flex flex-col flex-1 mb-2">
				<span class="text-xs text-gray-400 ml-1 capitalize">fotos</span>
				<div class="flex flex-wrap">
					{#each formdata.imagenes.split(',') as img, index}
						<span class="border text-xs p-1 mx-1 my-1 rounded-md hover:bg-white">
							<span class="bg-white px-1 py-0 rounded font-semibold hover:bg-red-400" on:click={()=>mover_foto(index)}>&lt;</span>
							<span class="bg-white px-1 py-0 rounded font-semibold hover:bg-red-400" on:click={()=>borrar_foto(index)}>&Cross;</span>
							<img src="{'upload/'+img}" alt="" width="40px">
						</span>
					{/each}
					
					<UploadImage image_id={item.id} on:uploaded={fileUplaoded}/>
				</div>
			</div>
 -->
		{/if}	
<!-- 
			<div class="flex flex-0 justify-around mb-2">
				<div class="text-black bg-yellow-300 rounded px-2 py-1 text-xs font-bold hover:bg-white" 
						on:click={cambiar}>{formdata.activo?'ACTIVO':'NO ACTIVO'}</div>
				<div class="text-black bg-pink-300 rounded px-2 py-1 text-xs font-bold hover:bg-white" 
						on:click={renovar}>RENOVAR</div>
			</div>
 -->
 		</form>
	</div>
	<code style="color:#999;position:fixed;bottom:10px;right:0;">ProductoForm</code>
</div>


<style>
	input, select{
		margin:0;
		padding:4px;
	}
	.lbl{
		font-size:0.8em;
		color:#777;
		margin-bottom:-2px;
	}
</style>